// extracted by mini-css-extract-plugin
export default {"pill":"pill_pill__kxKf7","label":"pill_label__skE1i","x":"pill_x__7q5vG"};